<label ngif>{{ inputLabel }}</label>
<!-- Calendar Input with  formcontrol (set of Form Control  on selection )  -->
<input
  *ngIf="!this.ngModelType"
  type="text"
  [formControl]="calendarFormControl.get('date')"
  [singleDatePicker]="true"
  ngxDaterangepickerMd
  class="form-control"
  [autoApply]="autoApply"
  [ngClass]="getValidationClass(formControl)"
  [locale]="locale"
  [showDropdowns]="showDropdowns"
  [alwaysShowCalendars]="alwaysShowCalendars"
  [minDate]="yearsValidations ? formatDate(pastTwoYears) : ''"
  [maxDate]="yearsValidations ? formatDate(futureTwoYears) : ''"
  (input)="onInput($event)"
  [isInvalidDate]="isInvalidDate" />

<!-- Calendar Input with Ng Model (emit value on selection )  -->
<input
  *ngIf="this.ngModelType"
  type="text"
  [(ngModel)]="data"
  (ngModelChange)="setForm(data)"
  [singleDatePicker]="true"
  ngxDaterangepickerMd
  class="form-control"
  [autoApply]="autoApply"
  [ngClass]="getValidationClass(formControl)"
  [locale]="locale"
  [showDropdowns]="showDropdowns"
  [alwaysShowCalendars]="alwaysShowCalendars" />

<span *ngIf="!this.ngModelType && formControl.errors?.invalidDate && !open" class="text-danger">
  Invalid date format. Use MM-DD-YYYY
</span>
